(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 117);
/******/ })
/************************************************************************/
/******/ ({

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "animate.css"
var external_animate_css_ = __webpack_require__(75);

// EXTERNAL MODULE: external "babel-runtime/core-js/object/assign"
var assign_ = __webpack_require__(8);
var assign_default = /*#__PURE__*/__webpack_require__.n(assign_);

// CONCATENATED MODULE: ./components/transition/normal.js
function transition(_ref) {
  var type = _ref.type,
      motion = _ref.motion;

  var cls = motion ? type + '-' + motion : type;
  this.props = {
    'enter-active-class': cls + '-enter ' + cls + '-enter-active',
    'leave-active-class': cls + '-leave ' + cls + '-leave-active'
  };
  return {
    props: {
      'enter-active-class': cls + '-enter ' + cls + '-enter-active',
      'leave-active-class': cls + '-leave ' + cls + '-leave-active'
    }
  };
}

/* harmony default export */ var normal = (transition);
// CONCATENATED MODULE: ./components/transition/collapse.js
function collapse() {
  return {
    props: {
      'enter-active-class': 'mds-motion-collapse mds-motion-collapse-active',
      'leave-active-class': 'mds-motion-collapse mds-motion-collapse-active'
    },
    on: {
      beforeEnter: function beforeEnter(el) {
        el.style.height = 0;
        el.style.opacity = 0;
      },
      enter: function enter(el) {
        el.style.height = el.scrollHeight + 'px';
        el.style.opacity = 1;
      },
      afterEnter: function afterEnter(el) {
        el.style.height = '';
        el.style.opacity = '';
      },
      beforeLeave: function beforeLeave(el) {
        el.style.height = el.offsetHeight + 'px';
        el.style.opacity = 1;
      },
      leave: function leave(el) {
        el.scrollHeight && (el.style.height = 0);
      },
      afterLeave: function afterLeave(el) {
        el.style.height = '';
        el.style.opacity = '';
      }
    }
  };
}

/* harmony default export */ var transition_collapse = (collapse);
// CONCATENATED MODULE: ./components/transition/animate.js
// animate 4.0.0+ 使用方法：animate__animated animate__tada
function animate(attrs) {
  return {
    props: {
      name: 'custom-classes-transition',
      'enter-class': attrs.enterClass ? 'animate__animated animate__' + attrs.enterClass : '',
      'enter-active-class': attrs.enterActiveClass ? 'animate__animated animate__' + attrs.enterActiveClass : '',
      'enter-to-class': attrs.enterToClass ? 'animate__animated animate__' + attrs.enterToClass : '',
      'leave-class': attrs.leaveClass ? 'animate__animated animate__' + attrs.leaveClass : '',
      'leave-active-class': attrs.leaveActiveClass ? 'animate__animated animate__' + attrs.leaveActiveClass : '',
      'leave-to-class': attrs.leaveToClass ? 'animate__animated animate__' + attrs.leaveToClass : ''
    }
  };
}

/* harmony default export */ var transition_animate = (animate);
// CONCATENATED MODULE: ./components/transition/transition.js




/* harmony default export */ var transition_transition = ({
  name: 'MdsTransition',
  functional: true,
  render: function render(h, ctx) {
    var attrs = ctx.props;
    var type = attrs.type;
    // todo tips
    var motion = function motion(type) {
      switch (type) {
        case 'animate':
          return new transition_animate(attrs);
        case 'fade':
        case 'move':
        case 'slide':
        case 'swing':
        case 'zoom':
          return new normal(attrs);
        case 'collapse':
          return new transition_collapse();
        default:
          return {};
      }
    };
    var data = assign_default()({}, ctx.data, motion(type));
    return h('transition', data, ctx.children);
  }
});
// CONCATENATED MODULE: ./components/transition/index.js


/* istanbul ignore next */
transition_transition.install = function (Vue) {
  Vue.component(transition_transition.name, transition_transition);
};
/* harmony default export */ var components_transition = __webpack_exports__["default"] = (transition_transition);

/***/ }),

/***/ 75:
/***/ (function(module, exports) {

module.exports = require("animate.css");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("babel-runtime/core-js/object/assign");

/***/ })

/******/ });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bic-fe/mds-ui/dist/transition.js
// module id = N+pu
// module chunks = 0